// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eoVPI","reviewRating":"style_reviewRating__cOhrv","reviewCount":"style_reviewCount__gSgMO"};